import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { MessagingQueryKey } from '../../keys'
import MessagingService from '../services'
import { IntervalMessageTransactionModel } from '../../types'

function useQueryGetIntervalMessageById(
	id: string,
	props?: UseBaseQueryOptions<IntervalMessageTransactionModel>,
) {
	return useQuery({
		queryKey: [MessagingQueryKey.GetIntervalMessageById, id],
		queryFn: () => MessagingService.getIntervalMessageById(id),
		enabled: !!id,
		...props,
	})
}

export default useQueryGetIntervalMessageById
